console.log("[pdp-sibling-strike-fastfetch] loaded");

(function () {
  const norm = (s) => (s || "").toString().trim();
  const cache = new Map(); // handle -> productJson
  let prefetchPromise = null;

  function getSelectedSize() {
    return (
      document.querySelector('input[type="radio"]:checked[name^="Size-"]')?.value || ""
    );
  }

  function extractHandleFromUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      const parts = u.pathname.split("/").filter(Boolean);
      const i = parts.indexOf("products");
      return i >= 0 ? parts[i + 1] : null;
    } catch {
      return null;
    }
  }

  function getSwatchNodes() {
    // Your swatches are clickable wrappers that contain .pdp-sibling-swatch__dot
    return Array.from(document.querySelectorAll(".pdp-sibling-swatch"));
  }

  function getHandleFromSwatch(swatch) {
    const href = swatch.getAttribute("href") || swatch.closest("a")?.getAttribute("href") || "";
    return extractHandleFromUrl(href);
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (cache.has(handle)) return cache.get(handle);

    const json = await fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);

    cache.set(handle, json);
    return json;
  }

  function isSizeAvailable(productJson, size) {
    if (!productJson || !size) return true; // if unknown, don't strike
    const target = norm(size);
    return (productJson.variants || []).some(
      (v) => v.available && norm(v.option1) === target
    );
  }

  async function prefetchAll() {
    // Only run once (unless new swatches appear later; then we call again)
    const swatches = getSwatchNodes();
    const handles = Array.from(
      new Set(swatches.map(getHandleFromSwatch).filter(Boolean))
    );

    if (!handles.length) return;

    console.log("[pdp-sibling-strike-fastfetch] prefetch handles:", handles.length);

    // Parallel fetch all, fill cache
    await Promise.all(handles.map(fetchProduct));
  }

  function applyStrikes() {
    const size = norm(getSelectedSize());
    const swatches = getSwatchNodes();

    swatches.forEach((sw) => {
      const handle = getHandleFromSwatch(sw);
      const json = handle ? cache.get(handle) : null;

      // If we haven't fetched it yet, don't strike yet (prevents “everything struck”)
      if (!json || !size) {
        sw.classList.remove("is-oos-for-size");
        return;
      }

      const available = isSizeAvailable(json, size);
      sw.classList.toggle("is-oos-for-size", !available);
    });
  }

  async function init() {
    // 1) Clear any old state
    getSwatchNodes().forEach((sw) => sw.classList.remove("is-oos-for-size"));

    // 2) Prefetch once, then apply immediately
    if (!prefetchPromise) {
      prefetchPromise = prefetchAll().then(() => {
        applyStrikes();
      });
    } else {
      // if already prefetching/prefetched
      prefetchPromise.then(applyStrikes);
    }
  }

  // Run on load + size changes
  document.addEventListener("DOMContentLoaded", () => {
    init();
    document.addEventListener("change", () => {
      // strikes should be instant now because cache is filled
      applyStrikes();
    });
  });

  // Pitch often injects swatches after initial render → observe and re-init
  const obs = new MutationObserver(() => {
    // If swatches appear later or change count, re-init (prefetch new handles only)
    const swatches = getSwatchNodes();
    if (swatches.length) init();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
